import PptxGenJS from "pptxgenjs";

const cleanHTML = (html: string) => {
    if (!html) return "";
    return html.replace(/&nbsp;/g, ' ')
        .replace(/<br\s*[\/]?>/gi, "\n")
        .replace(/<[^>]*>?/gm, '')
        .trim();
};

export const slide8 = (pptx: PptxGenJS, data: any) => {
    const reportData = data?.data;
    const questionsAndFeedback = reportData?.participantReport?.openendedComments || [];
    const candidateName = data?.candidateName || 'Jane Doe';

    let currentPageNum = 8;

    questionsAndFeedback.forEach((q: any, qIdx: number) => {
        const questionText = q.question?.text || "";
        const allComments = q.comments?.filter((c: any) => c.questionSpoolAnswers?.[0]?.answer_text) || [];

        if (allComments.length === 0) return;

        // Group comments: Managers (Supervisors) vs Others
        const managersComments = allComments.filter((c: any) =>
            c.reviewer?.oneReview?.review_type?.toLowerCase() === "supervisor"
        );
        const otherComments = allComments.filter((c: any) =>
            c.reviewer?.oneReview?.review_type?.toLowerCase() !== "supervisor"
        );

        let slide = pptx.addSlide();

        const addPageHeader = (s: any) => {
            s.addImage({
                path: '/Access-Holdings-Logo.jpg',
                x: 0.5, y: 0.2, w: 1.3, h: 0.45
            });
            s.addText("General Comments", {
                x: 0.5, y: 0.65, w: 7.27, h: 0.5,
                fontSize: 20, bold: true, color: '000000'
            });
            s.addShape('line', {
                x: 0.5, y: 1.1, w: 7.27, h: 0,
                line: { color: '404040', width: 1.5 }
            });
            s.addText([
                { text: "• This section includes participants' responses to the open-ended questions; ", options: { fontSize: 10, color: '404040' } },
                { text: "they have not been edited in any way.", options: { fontSize: 10, color: '000000', bold: true } }
            ], { x: 0.5, y: 1.25, w: 7.27, h: 0.3 });
        };

        const addFooter = (s: any, pNum: number) => {
            s.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
                x: 0, y: 11.2, w: 7.8, h: 0.3, fontSize: 9, color: '666666', align: 'center'
            });
            // s.addText(`${pNum}`, {
            //     x: 7.8, y: 11.2, w: 0.4, h: 0.3, fontSize: 9, color: '666666', align: 'center'
            // });
        };

        addPageHeader(slide);
        addFooter(slide, currentPageNum);

        // Question Box
        const qTop = 1.7;
        slide.addShape('rect', {
            x: 0.5, y: qTop, w: 7.27, h: 0.9,
            line: { color: '404040', width: 1 }
        });
        slide.addText("QUESTION", {
            x: 0.6, y: qTop + 0.05, w: 1.5, h: 0.2,
            fontSize: 8, bold: true, color: '404040'
        });
        slide.addText(`${qIdx + 1}`, {
            x: 0.6, y: qTop + 0.25, w: 0.6, h: 0.5,
            fontSize: 28, color: '000000'
        });
        slide.addText(questionText, {
            x: 1.3, y: qTop + 0.2, w: 6.2, h: 0.6,
            fontSize: 12, color: '404040', valign: 'middle'
        });

        let currentY = qTop + 1.1;

        const renderComments = (title: string, comments: any[]) => {
            if (comments.length === 0) return;

            // Check if we need a new slide for the title
            if (currentY > 9.5) {
                slide = pptx.addSlide();
                addPageHeader(slide);
                addFooter(slide, ++currentPageNum);
                currentY = 1.7;
            }

            slide.addText(title.toUpperCase(), {
                x: 0.5, y: currentY, w: 7.27, h: 0.2,
                fontSize: 10, bold: true, color: '000000'
            });
            slide.addShape('line', {
                x: 0.5, y: currentY + 0.2, w: 7.27, h: 0,
                line: { color: 'A6A6A6', width: 1 }
            });
            currentY += 0.3;

            comments.forEach((c) => {
                const text = cleanHTML(c.questionSpoolAnswers?.[0]?.answer_text || "");
                const type = c.reviewer?.oneReview?.review_type || "Respondent";
                const displayLabel = title === "MANAGERS" ? "" : `[${type}] `;
                const displayText = /*displayLabel +*/ text;

                // Estimate height (crude)
                const estHeight = Math.ceil(displayText.length / 85) * 0.22 + 0.2;

                if (currentY + estHeight > 10.5) {
                    slide = pptx.addSlide();
                    addPageHeader(slide);
                    addFooter(slide, ++currentPageNum);
                    currentY = 1.7;

                    // Re-add title on new slide if overflowed
                    slide.addText(`${title.toUpperCase()} (cont'd)`, {
                        x: 0.5, y: currentY, w: 7.27, h: 0.2,
                        fontSize: 10, bold: true, color: '000000'
                    });
                    slide.addShape('line', {
                        x: 0.5, y: currentY + 0.2, w: 7.27, h: 0,
                        line: { color: 'A6A6A6', width: 1 }
                    });
                    currentY += 0.3;
                }

                slide.addText(displayText, {
                    x: 0.7, y: currentY, w: 6.8, h: estHeight,
                    fontSize: 9, color: '404040', bullet: { indent: 10 }
                });
                currentY += estHeight + 0.1;
            });
            currentY += 0.2;
        };

        renderComments("MANAGERS", managersComments);
        renderComments("Other Raters", otherComments);

        currentPageNum++;
    });
};
